export default {
  title: 'Modifica disponibilità',
  amend_availabilities_form: {
    date: {
      label: 'Seleziona una data',
    },
    times: {
      label: 'Turni e orari di apertura',
      description:
        'Definisci gli orari di apertura per la data selezionata. Allunga, accorcia o blocca i turni. Almeno un turno deve essere aperto.',
      breakfast: {
        label: 'Colazione',
      },
      lunch: {
        label: 'Pranzo',
      },
      dinner: {
        label: 'Cena',
      },
    },
  },
  reason: {
    label: 'Aggiungi un motivo (opzionale)',
    placeholder: 'Inserisci descrizione...',
  },
  buttons: {
    save: 'Salva',
  },
  projects: {
    online_shop: 'Negozio online',
    reservations: 'Prenotazioni',
    storefront: 'Vetrina',
  },
  error_messages: {
    creation_failed: 'Creazione eccezione fallita',
  },
};
